import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SupportModalIdSubComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';

/**
 * 搭乗者情報入力画面　ヘッダー
 */
@Component({
  selector: 'asw-passenger-information-input-modal-header',
  templateUrl: './passenger-information-input-modal-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PassengerInformationInputModalHeaderComponent extends SupportModalIdSubComponent {
  constructor(private _common: CommonLibService) {
    super(_common);
  }

  override init(): void {
    /* override abstract init function of base class */
  }

  /**
   * (2) 閉じるボタン押下処理 ※全体イメージ
   */
  public onClickCloseModal() {
    this.close();
  }

  override reload(): void {
    /* override abstract reload function of base class */
  }

  override destroy(): void {
    /* override abstract destroy function of base class */
  }
}
